import React from 'react';
import { Box, Heading } from '@hover/blueprint';
import { SharedFaq } from '../common';
import { VINYL_SIDING_ESTIMATOR_FAQ } from '../../constants/vinylSidingEstimator';

const FAQ: React.FC = () => (
  <Box
    w="100%"
    flexDir="column"
    alignItems="center"
    py={{ base: 700, tablet: 1000 }}
    px={{ base: '500', tablet: '56px' }}
  >
    <Heading
      as="h2"
      isLight
      size={{ base: 500, tablet: 600, desktop: 700 }}
      marginBottom={{ base: 800, tablet: '88px', desktop: '88px' }}
    >
      Frequently asked questions
    </Heading>
    <SharedFaq questions={VINYL_SIDING_ESTIMATOR_FAQ} />
  </Box>
);

export default FAQ;
